module.exports = __webpack_public_path__ + "img/trading.ef04d485.png";